// Site-wide footer. Lives at the bottom of every page (public OR logged-in)
// so users always have one click to About / Contact / policies.
//
// iter 95 — independence rewrite:
//   • Footer copy is fully neutralised — no references to any public body,
//     programme name, ministry, scheme, or affiliation. Platform is framed
//     purely as a private digital productivity / documentation utility.
//   • Inlines the canonical independence disclaimer (same copy as
//     DisclaimerBanner) above the columns so every page surfaces it
//     without an additional component import.
import { Link } from "react-router-dom";
import { DISCLAIMER_TEXT } from "@/components/DisclaimerBanner";

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="mt-12 border-t border-border bg-sand-100 text-ink-900"
    >
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
        {/* Independence disclaimer — always visible above the link columns
            so every page meets Trust & Safety expectations. */}
        <div
          data-testid="footer-disclaimer"
          className="mb-8 rounded-xl border border-amber-200 bg-amber-50/60 px-4 py-3 text-[0.72rem] leading-relaxed text-ink-700 sm:text-xs"
        >
          <b className="text-ink-900">Independent Platform Notice:</b> {DISCLAIMER_TEXT}
        </div>

        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <p className="font-heading text-2xl font-semibold tracking-tight">MDM Sahayak</p>
            <p className="mt-3 text-sm text-ink-700">
              An independent digital productivity &amp; documentation assistance platform.
              Built to help users simplify repetitive administrative and reporting workflows.
            </p>
            <a
              href="https://wa.me/918093414633"
              target="_blank"
              rel="noreferrer"
              className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-moss px-3 py-1.5 text-xs font-semibold text-white hover:bg-moss-dark"
              data-testid="footer-whatsapp-link"
            >
              💬 Chat on WhatsApp · +91 80934 14633
            </a>
          </div>
          <div>
            <p className="text-[0.7rem] font-semibold uppercase tracking-[0.22em] text-clay">Product</p>
            <ul className="mt-3 space-y-2 text-sm">
              <li><Link to="/dashboard" className="hover:text-clay">Dashboard</Link></li>
              <li><Link to="/daily" className="hover:text-clay">Daily Entry</Link></li>
              <li><Link to="/mdcf" className="hover:text-clay">Monthly MDCF</Link></li>
              <li><Link to="/" className="hover:text-clay">Quarterly Reports</Link></li>
              <li><Link to="/funds" className="hover:text-clay">Fund Management</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-[0.7rem] font-semibold uppercase tracking-[0.22em] text-clay">Company</p>
            <ul className="mt-3 space-y-2 text-sm">
              <li><Link to="/about" className="hover:text-clay" data-testid="footer-about-link">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-clay" data-testid="footer-contact-link">Contact Us</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-[0.7rem] font-semibold uppercase tracking-[0.22em] text-clay">Legal</p>
            <ul className="mt-3 space-y-2 text-sm">
              <li><Link to="/privacy" className="hover:text-clay" data-testid="footer-privacy-link">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-clay" data-testid="footer-terms-link">Terms &amp; Conditions</Link></li>
              <li><Link to="/refund" className="hover:text-clay" data-testid="footer-refund-link">Refund Policy</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-border pt-6 text-xs text-ink-700 sm:flex-row sm:items-center">
          <p>© {year} MDM Sahayak. All rights reserved. Independent SaaS productivity platform.</p>
          <p>
            For support, write to <a href="mailto:support@mdmsahayak.com" className="hover:text-clay">support@mdmsahayak.com</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
